import {ApolloClient, InMemoryCache} from '@apollo/client';

export const apolloClient = new ApolloClient({
	uri: '/api/graphql',
	cache: new InMemoryCache(),
});

export * from './__generated__/gql';
export * from './__generated__/graphql';
